export default __webpack_public_path__ + "0a78f59a0890a0e48b70c4426a0ae08f.png";